import type { UseQueryResult } from "@tanstack/react-query";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCurrentStateAndParamsWithFixedDomain";
import { companyAnalysisQueryKeys } from "app/pages/sales-intelligence/modules/company-analysis/queries/queryKeyFactory";
import { selectCountByContactsRequestDto } from "app/pages/sales-intelligence/modules/company-analysis/store/contacts/selectors";
import type { ContactsCountry } from "app/pages/sales-intelligence/modules/company-analysis/types/contacts";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

const useContactsCountByCountries = (): UseQueryResult<ContactsCountry[]> => {
    const { params } = useCurrentStateAndParamsWithFixedDomain();
    const dto = useSelector((state) => selectCountByContactsRequestDto(state, params.key));

    return useQuery({
        queryKey: companyAnalysisQueryKeys.contactsCountByCountries(params.key),
        queryFn: () => salesApiService.contacts.fetchCountries(dto),
        select: (data) =>
            data.contactsCountries.map((l) => ({
                id: l.country.id,
                text: l.country.name,
                contactsCount: l.contactsCount,
            })),
        placeholderData: keepPreviousData,
        enabled: !!params.key && !!dto,
    });
};
export default useContactsCountByCountries;
